import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import React, { useState, useEffect } from 'react';
import './TextEditor.css';

const TextEditor: React.FC<any> = (props) => {
  const {
    onChange,
    defaultValue,
    value: valueProps,
    error,
  } = props;
  const [editorContent, setEditorContent] = useState<any>(defaultValue);

  useEffect(() => {
    setEditorContent(valueProps);
  }, [valueProps]);

  const handleEditorChange = (content: any): void => {
    if (content !== '<p><br></p>') {
      setEditorContent(content);
      if (onChange) {
        onChange(content);
      }
    } else {
      setEditorContent('');
      onChange('');
    }
  };

  const toolbarOptions = [{ header: [1, 2, false] }, 'bold', 'italic', 'underline',
    { list: 'ordered' }, { list: 'bullet' }, { align: [] }, 'link']; // toggled buttons;

  return (
    <div
      className={error ? 'is-invalid' : ''}
    >
      <ReactQuill
        className="ql-container"
        value={editorContent}
        onChange={handleEditorChange}
        modules={{
          toolbar: [
            toolbarOptions,
          ],
        }}
        placeholder="Write message"
        theme="snow"
      />
    </div>
  );
};

export default TextEditor;
